<template>
  <div id="app">
    <keep-alive>
      <router-view ref="app-body-view" :key="$route.fullPath"
                   v-if="this.$route.meta.keepAlive"/>
    </keep-alive>
    <router-view ref="app-body-view" :key="$route.fullPath"
                 v-if="!this.$route.meta.keepAlive"/>

  </div>
</template>

<script>
import store from "./store";
import router from "./router";

export default {
  name: 'App',
  data() {
    return {
      reachBottom: true,
    }
  },
  watch: {

  },
  methods: {
    scroll(e) {
      //文档内容实际高度（包括超出视窗的溢出部分）
      let scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      //滚动条滚动距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //窗口可视范围高度
      let clientHeight = window.innerHeight || Math.min(document.documentElement.clientHeight, document.body.clientHeight);

      if (clientHeight + scrollTop >= scrollHeight - 50) {
        if (this.reachBottom) {
          console.log('onReachBottom')
          this.reachBottom = false;
          // TODO 需要优化，可能不是第0个对象
          let view = this.$refs['app-body-view'].$children[0];
          view && view.reachBottom && view.onReachBottom && view.onReachBottom();
        }
      } else {
        this.reachBottom || (this.reachBottom = true)
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, false);
   
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll, false);
  },

}
</script>

<style lang="scss" >
#app {
  min-height: 100vh;
  width: 100vw;
}

@font-face {
  font-family: "iconfont"; /* project id 1908491 */
  src: url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.eot");
  src: url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.eot?#iefix") format("embedded-opentype"),
  url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.woff2") format("woff2"),
  url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.woff") format("woff"),
  url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.ttf") format("truetype"),
  url("//at.alicdn.com/t/font_1908491_8b4i7ixgk9f.svg#iconfont") format("svg");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}


.ShareQRCode_confirm {
  .weui-dialog {
    height: 5rem !important;
  }
  .weui-dialog__bd {
    height: 3.12rem;
    padding: 0 0.52rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue